(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7358],{

/***/ 36630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ apolloClientQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);



var apolloClientQuery = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(client, query, variables) {
        var ref, queryResponse, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        client.query({
                            query: query,
                            variables: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, variables),
                            errorPolicy: "all"
                        })
                    ];
                case 1:
                    queryResponse = _state.sent();
                    if (queryResponse.errors && ((ref = queryResponse.errors) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                        throw new Error(queryResponse.errors[0].message);
                    }
                    return [
                        2,
                        {
                            queryResponse: queryResponse,
                            error: null
                        }
                    ];
                case 2:
                    err = _state.sent();
                    return [
                        2,
                        {
                            queryResponse: null,
                            error: err
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function apolloClientQuery(client, query, variables) {
        return _ref.apply(this, arguments);
    };
}();



/***/ }),

/***/ 96301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _generated_globalTypes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79967);
/* harmony import */ var _contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73739);





var ref = next_config__WEBPACK_IMPORTED_MODULE_1___default()(), NEXT_PUBLIC_APP_URL = ref.publicRuntimeConfig.NEXT_PUBLIC_APP_URL;
var PageMeta = function(param) {
    var hrefLangLinks = param.hrefLangLinks, title = param.title, canonicalUrl = param.canonicalUrl, metaDescriptions = param.metaDescriptions, metaKeywords = param.metaKeywords, _paginationPageCount = param.paginationPageCount, paginationPageCount = _paginationPageCount === void 0 ? 1 : _paginationPageCount, _paginationCurrentPage = param.paginationCurrentPage, paginationCurrentPage = _paginationCurrentPage === void 0 ? 1 : _paginationCurrentPage, isCostGuidePage = param.isCostGuidePage, seoSegmentNamePlural = param.seoSegmentNamePlural, isCampsAndActivitiesPage = param.isCampsAndActivitiesPage;
    var ref = (0,_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_4__/* .usePageAttributes */ .l)(), segmentNamePlural = ref.segmentNamePlural, pageType = ref.pageType, city = ref.city, state = ref.state;
    var logoPath = "".concat(NEXT_PUBLIC_APP_URL, "/img/care-no-tag.jpg?v=2");
    var prevLink;
    var nextLink;
    var canonicalPageUrl;
    var newTitle;
    var noindexPage = pageType === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_3__/* .SEOSegmentationPageType.LOCAL */ .a6.LOCAL && paginationCurrentPage > 1 || isCampsAndActivitiesPage && paginationCurrentPage > 1;
    if (paginationCurrentPage > 1) {
        if (pageType === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_3__/* .SEOSegmentationPageType.LOCAL */ .a6.LOCAL) {
            newTitle = "Page ".concat(paginationCurrentPage, " - Top ").concat(segmentNamePlural, " in ").concat(city, ", ").concat(state);
        } else {
            newTitle = "Page ".concat(paginationCurrentPage, " - Top ").concat(seoSegmentNamePlural !== null && seoSegmentNamePlural !== void 0 ? seoSegmentNamePlural : segmentNamePlural);
        }
        canonicalPageUrl = "".concat(canonicalUrl, "-page").concat(paginationCurrentPage);
        if (paginationCurrentPage < paginationPageCount) {
            nextLink = "".concat(canonicalUrl, "-page").concat(paginationCurrentPage + 1);
            prevLink = paginationCurrentPage === 2 ? canonicalUrl : "".concat(canonicalUrl, "-page").concat(paginationCurrentPage - 1);
        } else {
            prevLink = "".concat(canonicalUrl);
        }
    } else if (paginationCurrentPage === 1) {
        newTitle = title;
        canonicalPageUrl = canonicalUrl;
        if (paginationPageCount > 1) {
            nextLink = "".concat(canonicalUrl, "-page2");
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            hrefLangLinks && hrefLangLinks.map(function(param) {
                var languageCode = param.languageCode, countryCode = param.countryCode, url = param.url;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "alternate",
                    href: url,
                    hrefLang: "".concat(languageCode, "-").concat(countryCode)
                }, url);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: newTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                httpEquiv: "X-UA-Compatible",
                content: "IE=edge,chrome=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: metaDescriptions
            }),
            metaKeywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: metaKeywords
            }),
            noindexPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, follow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalPageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "verify-v1",
                content: "zz15lR180u9eCqTfur/9l+bMP75AampYtDEm6OnbkWY="
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: newTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: logoPath
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: metaDescriptions
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "Care.com"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "image/jpeg",
                property: "og:image:type"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "1080",
                property: "og:image:width"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "1080",
                property: "og:image:height"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "fb:page_id",
                content: "6030284861"
            }),
            isCostGuidePage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "shortcut icon",
                href: "https://www.care.com/img/crcm-favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        logo: logoPath,
                        name: "Care.com",
                        sameAs: [
                            "https://www.facebook.com/caredotcom/",
                            "https://twitter.com/CareDotCom",
                            "https://www.instagram.com/careorg/",
                            "https://www.linkedin.com/company/care-com", 
                        ],
                        url: "https://www.care.com"
                    })
                }
            }),
            !isCostGuidePage && nextLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "next",
                href: nextLink
            }),
            !isCostGuidePage && prevLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prev",
                href: prevLink
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageMeta);


/***/ }),

/***/ 79556:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ costGuide_CostGuideSlimSearch; }
});

// UNUSED EXPORTS: costGuideVerticalOptions

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(82222);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js + 2 modules
var useLazyQuery = __webpack_require__(45910);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/TypeAhead/TypeAhead.js + 1 modules
var TypeAhead = __webpack_require__(83081);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/Icon24Chevron.js
var Icon24Chevron = __webpack_require__(84899);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(61730);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControl/FormControl.js + 1 modules
var FormControl = __webpack_require__(94054);
// EXTERNAL MODULE: ./node_modules/@mui/material/NativeSelect/NativeSelect.js
var NativeSelect = __webpack_require__(88566);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 3 modules
var Accordion = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(38895);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(22797);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/lodash-es/find.js + 8 modules
var find = __webpack_require__(80991);
// EXTERNAL MODULE: ./node_modules/lodash-es/isEmpty.js
var isEmpty = __webpack_require__(79697);
// EXTERNAL MODULE: ./node_modules/lodash-es/isArray.js
var isArray = __webpack_require__(27771);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 12 modules
var lib = __webpack_require__(68806);
// EXTERNAL MODULE: ./src/API/utils.ts
var utils = __webpack_require__(36630);
;// CONCATENATED MODULE: ./src/API/costGuideLocation.ts



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query costGuideLocation($criteria: CostGuideLocationInput!, $limit: Int!) {\n    costGuideLocation(criteria: $criteria, limit: $limit) {\n      __typename\n      ... on CostGuideLocationSuccess {\n        cityList {\n          slug\n          location {\n            city\n            state {\n              name\n              stateCode\n            }\n          }\n        }\n      }\n      ... on CostGuideLocationError {\n        errors {\n          __typename\n          message\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var COST_GUIDE_LOCATION = (0,lib/* default */.ZP)(_templateObject());
// make API call and handle any errors. Pass data to Props.
var costGuideLocationQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(client, log, variables) {
        var ref, queryResponse, error, data, errors, responseError;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,utils/* apolloClientQuery */.M)(client, COST_GUIDE_LOCATION, variables)
                    ];
                case 1:
                    ref = _state.sent(), queryResponse = ref.queryResponse, error = ref.error;
                    // unknown error
                    if (error) {
                        return [
                            2,
                            {
                                error: error
                            }
                        ];
                    }
                    data = queryResponse.data, errors = queryResponse.errors, responseError = queryResponse.error;
                    // GraphQL errors that occur while processing a GraphQL operation (resulting in built-in error codes such as INTERNAL_SERVER_ERROR)
                    if (errors && errors.length > 0) {
                        return [
                            2,
                            {
                                error: errors
                            }
                        ];
                    }
                    // Coverage for 'error' property in queryResponse
                    if (responseError) {
                        return [
                            2,
                            {
                                error: responseError
                            }
                        ];
                    }
                    // known error
                    if (data.costGuideLocation.__typename === "CostGuideLocationError") {
                        log.error("[GraphQL errors]: ".concat(errors));
                        return [
                            2,
                            {
                                error: data.costGuideLocation.errors
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            cityList: data.costGuideLocation.cityList,
                            error: null
                        }
                    ];
            }
        });
    });
    return function costGuideLocationQuery(client, log, variables) {
        return _ref.apply(this, arguments);
    };
}();


;// CONCATENATED MODULE: ./src/API/costGuideServiceSpecialties.ts



function costGuideServiceSpecialties_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query costGuideServiceSpecialties($serviceId: ID!) {\n    costGuideServiceSpecialties(serviceId: $serviceId) {\n      __typename\n      ... on CostGuideServiceSpecialtiesSuccess {\n        serviceSpecialties {\n          specialties {\n            name\n            slug\n          }\n        }\n      }\n      ... on CostGuideServiceSpecialtiesError {\n        errors {\n          message\n        }\n      }\n    }\n  }\n"
    ]);
    costGuideServiceSpecialties_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var COST_GUIDE_SERVICE_SPECIALTIES = (0,lib/* default */.ZP)(costGuideServiceSpecialties_templateObject());
// make API call and handle any errors. Pass data to Props.
var costGuideServiceSpecialtiesQuery = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(client, log, variables) {
        var ref, ref1, ref2, ref3, queryResponse, error, data, errors, responseError;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,utils/* apolloClientQuery */.M)(client, COST_GUIDE_SERVICE_SPECIALTIES, variables)
                    ];
                case 1:
                    ref3 = _state.sent(), queryResponse = ref3.queryResponse, error = ref3.error;
                    // unknown error
                    if (error) {
                        return [
                            2,
                            {
                                serviceSpecialties: null,
                                error: error
                            }
                        ];
                    }
                    data = queryResponse.data, errors = queryResponse.errors, responseError = queryResponse.error;
                    // GraphQL errors that occur while processing a GraphQL operation (resulting in built-in error codes such as INTERNAL_SERVER_ERROR)
                    if (errors && errors.length > 0) {
                        return [
                            2,
                            {
                                serviceSpecialties: null,
                                error: errors
                            }
                        ];
                    }
                    // Coverage for 'error' property in queryResponse
                    if (responseError) {
                        return [
                            2,
                            {
                                serviceSpecialties: null,
                                error: responseError
                            }
                        ];
                    }
                    // known error
                    if (((ref = data.costGuideServiceSpecialties) === null || ref === void 0 ? void 0 : ref.__typename) === "CostGuideServiceSpecialtiesError") {
                        log.error("[GraphQL errors]: ".concat(errors));
                        return [
                            2,
                            {
                                serviceSpecialties: null,
                                error: data.costGuideServiceSpecialties.errors
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            serviceSpecialties: (data === null || data === void 0 ? void 0 : (ref1 = data.costGuideServiceSpecialties) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.serviceSpecialties) === null || ref2 === void 0 ? void 0 : ref2.specialties) || null,
                            error: null
                        }
                    ];
            }
        });
    });
    return function costGuideServiceSpecialtiesQuery(client, log, variables) {
        return _ref.apply(this, arguments);
    };
}();


;// CONCATENATED MODULE: ./src/utils/createTypeAheadOptions.ts
var createTypeAheadOptions = function(cityList) {
    if (cityList.length < 1) {
        return [];
    }
    return cityList.map(function(entry) {
        return {
            label: "".concat(entry.location.city, ", ").concat(entry.location.state.stateCode),
            value: entry.slug
        };
    });
};

// EXTERNAL MODULE: ./src/lib/analyticsHelper.tsx
var analyticsHelper = __webpack_require__(883);
// EXTERNAL MODULE: ./src/components/hooks/useFeatureFlag.ts
var useFeatureFlag = __webpack_require__(19500);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
;// CONCATENATED MODULE: ./src/components/pages/costGuide/CostGuideSlimSearch.tsx
/* eslint-disable complexity */ 

















var ref = config_default()(), NEXT_PUBLIC_APP_URL = ref.publicRuntimeConfig.NEXT_PUBLIC_APP_URL;
var costGuideVerticalOptions = {
    CHILD_CARE: {
        label: "Child care",
        value: "child-care"
    },
    BABYSITTER: {
        label: "Babysitters",
        value: "babysitters"
    },
    NANNY: {
        label: "Nannies",
        value: "nannies"
    },
    SENIOR_CARE: {
        label: "Senior care",
        value: "senior-care"
    },
    PET_CARE: {
        label: "Pet care",
        value: "pet-care"
    },
    HOUSEKEEPING: {
        label: "Housekeeping",
        value: "housekeeping"
    },
    TUTORING: {
        label: "Tutoring",
        value: "tutors"
    },
    CARE_GIGS: {
        label: "Personal assistants",
        value: "personal-assistants"
    }
};
var CostGuideSlimSearch = function(param) {
    var searchDefaults = param.searchDefaults, _isLandingPage = param.isLandingPage, isLandingPage = _isLandingPage === void 0 ? false : _isLandingPage, _segmentation = param.segmentation, segmentation = _segmentation === void 0 ? undefined : _segmentation, _expanded = param.expanded, expanded = _expanded === void 0 ? false : _expanded, _costGuideServiceSpecialties = param.costGuideServiceSpecialties, costGuideServiceSpecialties = _costGuideServiceSpecialties === void 0 ? [] : _costGuideServiceSpecialties;
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useMediaQuery/* default */.Z)(function(theme) {
        return theme.breakpoints.down("md");
    });
    var defaultSearchLocation = (searchDefaults === null || searchDefaults === void 0 ? void 0 : searchDefaults.location) ? "".concat(searchDefaults.location.location.city, ", ").concat(searchDefaults.location.location.state.stateCode) : "";
    var defaultSearchLocationSlug = (searchDefaults === null || searchDefaults === void 0 ? void 0 : searchDefaults.location) ? "".concat(searchDefaults.location.slug) : "";
    var getPreSelectedVertical = function() {
        var ref;
        if ((searchDefaults === null || searchDefaults === void 0 ? void 0 : (ref = searchDefaults.service) === null || ref === void 0 ? void 0 : ref.serviceId) && costGuideVerticalOptions[searchDefaults.service.serviceId]) {
            return costGuideVerticalOptions[searchDefaults.service.serviceId].value;
        }
        if (segmentation) {
            var ref1;
            return ((ref1 = (0,find/* default */.Z)(costGuideVerticalOptions, function(vertical) {
                return vertical.value === segmentation;
            })) === null || ref1 === void 0 ? void 0 : ref1.value) || "";
        }
        return "";
    };
    var preSelectedVertical = getPreSelectedVertical();
    var ref = (0,react.useState)(preSelectedVertical), selectedVertical = ref[0], setSelectedVertical = ref[1];
    var ref1 = (0,react.useState)(defaultSearchLocation), locationInputValue = ref1[0], setLocationInputValue = ref1[1];
    var ref2 = (0,react.useState)(defaultSearchLocationSlug), locationValue = ref2[0], setLocationValue = ref2[1];
    var ref3 = (0,react.useState)("Enter city name"), noMatchMessage = ref3[0], setNoMatchMessage = ref3[1];
    var ref4 = (0,react.useState)([]), locationOptions = ref4[0], setLocationOptions = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(COST_GUIDE_LOCATION, {
        onCompleted: function(data) {
            var refinedOptions = (data === null || data === void 0 ? void 0 : data.costGuideLocation.__typename) === "CostGuideLocationSuccess" ? data.costGuideLocation.cityList : [];
            if (refinedOptions.length === 0) setNoMatchMessage("No options");
            setLocationOptions(createTypeAheadOptions(refinedOptions));
        }
    }), 1), getLocationOptions = ref5[0];
    var getPreSelectedSpecialty = function() {
        var ref;
        if ((searchDefaults === null || searchDefaults === void 0 ? void 0 : (ref = searchDefaults.service) === null || ref === void 0 ? void 0 : ref.serviceId) && costGuideServiceSpecialties) {
            var ref1;
            return ((ref1 = costGuideServiceSpecialties.find(function(specialty) {
                return specialty.slug === searchDefaults.service.slug;
            })) === null || ref1 === void 0 ? void 0 : ref1.slug) || "";
        }
        return "";
    };
    var preSelectedSpecialty = getPreSelectedSpecialty();
    var specialtiesDropdownFlag = (0,useFeatureFlag/* default */.Z)(constants/* UI_FEATURE_FLAGS.COST_GUIDE_SPECIALTY.id */.WV.COST_GUIDE_SPECIALTY.id);
    var ref6 = (0,react.useState)(preSelectedSpecialty), selectedSpecialty = ref6[0], setSelectedSpecialty = ref6[1];
    var ref7 = (0,react.useState)(costGuideServiceSpecialties), specialtyOptions = ref7[0], setSpecialtyOptions = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(COST_GUIDE_SERVICE_SPECIALTIES, {
        onCompleted: function(data) {
            var ref;
            var refinedOptions = (data === null || data === void 0 ? void 0 : (ref = data.costGuideServiceSpecialties) === null || ref === void 0 ? void 0 : ref.__typename) === "CostGuideServiceSpecialtiesSuccess" ? data.costGuideServiceSpecialties.serviceSpecialties.specialties : [];
            setSpecialtyOptions(refinedOptions);
        }
    }), 1), getSpecialitiesOptions = ref8[0];
    var showSpecialtiesDropdown = (typeof specialtiesDropdownFlag === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(specialtiesDropdownFlag)) !== undefined && (specialtiesDropdownFlag === null || specialtiesDropdownFlag === void 0 ? void 0 : specialtiesDropdownFlag.variationIndex) === 1;
    var getServiceIdBySegmentation = function(segmentationValue) {
        return Object.keys(costGuideVerticalOptions).find(function(key) {
            return costGuideVerticalOptions[key].value === segmentationValue;
        });
    };
    var handleVerticalChange = function(event) {
        setSelectedVertical(event.target.value);
        var selectedServiceId = getServiceIdBySegmentation(event.target.value);
        if (selectedServiceId) {
            setSelectedSpecialty("");
            getSpecialitiesOptions({
                variables: {
                    serviceId: constants/* ServiceIdForMember */.u2[selectedServiceId]
                }
            });
        }
    };
    var handleSpecialtyChange = function(event) {
        setSelectedSpecialty(event.target.value);
    };
    var handleSearchButton = function() {
        var url = !(0,isEmpty/* default */.Z)(selectedSpecialty) ? "/cost/".concat(selectedSpecialty, "/").concat(locationValue) : "/cost/".concat(selectedVertical, "/").concat(locationValue);
        var amplitudeData = {
            cta_text: "Search",
            cta_type: "button",
            url: "".concat(NEXT_PUBLIC_APP_URL).concat(url),
            url_path: url
        };
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.ctaInteracted */.Sj.ctaInteracted, amplitudeData);
        router.push(url, undefined, {
            shallow: false
        });
    };
    var ref9 = (0,react.useState)(expanded), isSearchAccordionExpanded = ref9[0], setIsSearchAccordionExpanded = ref9[1];
    var handleSearchAccordionChange = function() {
        setIsSearchAccordionExpanded(function(prevState) {
            return !prevState;
        });
    };
    var formatInputValue = function(inputValue) {
        var inputValues = inputValue.split(" ");
        var cityInput = inputValues.slice(0, -1).join(" ");
        var stateCodeInput = inputValues[inputValues.length - 1];
        var stateCode = constants/* mapStringtoUsStateCode */.VW[stateCodeInput.toUpperCase()];
        if (typeof stateCode !== "undefined" && (inputValues.length === 2 || inputValues.length === 3) && !inputValue.includes(",")) {
            return [
                cityInput,
                stateCodeInput
            ].join(", ");
        }
        if (inputValues.length === 2 && stateCodeInput.length === 3) {
            return inputValue.replace(",", "");
        }
        return inputValue;
    };
    var VerticalSelect = /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
        variant: "standard",
        sx: {
            width: "100%",
            backgroundColor: "background.default",
            borderRadius: "12px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NativeSelect/* default */.Z, {
            IconComponent: Icon24Chevron/* default */.Z,
            onChange: handleVerticalChange,
            value: selectedVertical,
            inputProps: {
                "aria-label": "CostGuideVertical",
                name: "CostGuideVertical"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                    value: "",
                    disabled: true,
                    children: "Choose category"
                }, "landing-page"),
                Object.entries(costGuideVerticalOptions).map(function(vertical) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: vertical[1].value,
                        children: vertical[1].label
                    }, vertical[0]);
                })
            ]
        })
    });
    var SpecialtiesSelect = /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
        variant: "standard",
        sx: {
            width: "100%",
            backgroundColor: "background.default",
            borderRadius: "12px"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(NativeSelect/* default */.Z, {
            IconComponent: Icon24Chevron/* default */.Z,
            onChange: handleSpecialtyChange,
            value: selectedSpecialty,
            inputProps: {
                "aria-label": "CostGuideSpecialties",
                name: "CostGuideSpecialties"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                    value: "",
                    children: "Specialized service"
                }, "specialized-skills"),
                specialtyOptions && Object.entries(specialtyOptions).map(function(specialty) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                        value: specialty[1].slug,
                        children: specialty[1].name
                    }, specialty[0]);
                })
            ]
        })
    });
    var TypeAheadComponent = /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeAhead/* default */.Z, {
        placeholder: "Choose location",
        noMatchMessage: noMatchMessage,
        id: "location-autocomplete",
        enablePortal: true,
        multiple: false,
        options: locationOptions,
        inputValue: locationInputValue,
        clearOnBlur: false,
        selectOnFocus: false,
        openOnFocus: false,
        onInputChange: function(_event, newValue, reason) {
            // prevent input from clearing the default location on initial load
            if (newValue === "" && reason === "reset") return;
            var value = formatInputValue(newValue);
            setLocationInputValue(value);
            if (newValue !== "") {
                getLocationOptions({
                    variables: {
                        criteria: {
                            location: value
                        },
                        limit: 10
                    }
                });
            } else {
                setLocationOptions([]);
                setNoMatchMessage("Enter city name");
            }
        },
        value: {
            label: locationInputValue,
            value: locationValue
        },
        onValueChange: function(updated) {
            if (!(0,isArray/* default */.Z)(updated)) {
                setLocationValue(updated.value);
            }
        },
        sx: function(theme) {
            return {
                backgroundColor: theme.palette.care.white,
                borderRadius: "12px",
                "& .MuiInputBase-root": {
                    borderRadius: "12px !important"
                },
                "& .MuiInputBase-input": {
                    border: "solid 1px ".concat(theme.palette.care.grey[300], " !important"),
                    borderRadius: "12px !important",
                    fontWeight: "400 !important"
                }
            };
        }
    });
    var SearchButton = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
        disabled: !(selectedVertical && locationValue),
        color: "primary",
        variant: "contained",
        size: "medium",
        sx: function(theme) {
            return (0,_define_property/* default */.Z)({
                border: "none",
                mt: 1.5,
                mb: 1.5,
                width: "100%",
                height: "40px",
                fontSize: "1.125rem"
            }, theme.breakpoints.down("lg"), {
                maxWidth: "320px",
                fontSize: theme.spacing(2)
            });
        },
        onClick: handleSearchButton,
        children: "Search"
    });
    var MobileView = /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            pt: 1
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
            elevation: 0,
            expanded: isSearchAccordionExpanded,
            onChange: handleSearchAccordionChange,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                    expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24Chevron/* default */.Z, {}),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h3",
                        color: "text.primary",
                        children: "Search Care Costs"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                    sx: {
                        py: 1,
                        px: 2
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        container: true,
                        direction: "column",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: true,
                                children: VerticalSelect
                            }),
                            showSpecialtiesDropdown && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: true,
                                children: SpecialtiesSelect
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: true,
                                children: TypeAheadComponent
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    container: true,
                                    justifyContent: "center",
                                    children: SearchButton
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
    var DesktopView = /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: function(theme) {
            return (0,_define_property/* default */.Z)({
                backgroundColor: theme.palette.background.primary,
                padding: theme.spacing(1),
                textAlign: "center"
            }, theme.breakpoints.up("md"), {
                padding: theme.spacing(2, 0)
            });
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
            width: showSpecialtiesDropdown ? 965 : 800,
            mx: "auto",
            px: 1,
            py: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    width: "100%",
                    pb: 2,
                    display: "inline-block",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "h3",
                        color: "text.primary",
                        textAlign: "left",
                        children: "Search Care Costs"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    width: "100%",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        container: true,
                        alignItems: "center",
                        spacing: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 10,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    alignItems: "center",
                                    spacing: 1,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: true,
                                            children: VerticalSelect
                                        }),
                                        showSpecialtiesDropdown && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: true,
                                            children: SpecialtiesSelect
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: true,
                                            children: TypeAheadComponent
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 2,
                                children: SearchButton
                            })
                        ]
                    })
                })
            ]
        })
    });
    var MobileViewLandingPage = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        direction: "column",
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: true,
                children: VerticalSelect
            }),
            showSpecialtiesDropdown && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: true,
                children: SpecialtiesSelect
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: true,
                children: TypeAheadComponent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    container: true,
                    justifyContent: "center",
                    children: SearchButton
                })
            })
        ]
    });
    var DesktopViewLandingPage = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        container: true,
        alignItems: "center",
        spacing: 2,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 10,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    alignItems: "center",
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: true,
                            children: VerticalSelect
                        }),
                        showSpecialtiesDropdown && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: true,
                            children: SpecialtiesSelect
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: true,
                            children: TypeAheadComponent
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 2,
                children: SearchButton
            })
        ]
    });
    if (isLandingPage) {
        return isMobile ? MobileViewLandingPage : DesktopViewLandingPage;
    }
    return isMobile ? MobileView : DesktopView;
};
/* harmony default export */ var costGuide_CostGuideSlimSearch = (CostGuideSlimSearch);


/***/ }),

/***/ 85322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ HowItWorks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70891);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48885);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59334);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(46574);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(69417);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91509);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83496);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62724);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);
/* harmony import */ var _components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19147);






var ref = next_config__WEBPACK_IMPORTED_MODULE_1___default()(), NEXT_PUBLIC_APP_URL = ref.publicRuntimeConfig.NEXT_PUBLIC_APP_URL;
var HowItWorks = function(param) {
    var segmentationUrl = param.segmentationUrl, _isCostGuideLandingPage = param.isCostGuideLandingPage, isCostGuideLandingPage = _isCostGuideLandingPage === void 0 ? false : _isCostGuideLandingPage, segmentNameSingularLowerCase = param.segmentNameSingularLowerCase;
    var isSmallViewport = (0,_components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__/* .useResponsive */ .F)().isSmallViewport;
    var ctaText = isCostGuideLandingPage ? "Join free to get started" : "View ".concat(segmentNameSingularLowerCase, " profiles");
    var handleCtaBtn = function() {
        var amplitudeData = {
            cta_text: ctaText,
            cta_type: "button",
            url: "".concat(NEXT_PUBLIC_APP_URL).concat(segmentationUrl),
            url_path: segmentationUrl
        };
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.ctaInteracted */ .Sj.ctaInteracted, amplitudeData);
    };
    var hiwSteps = [
        {
            content: "Share details about your needs",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                size: isSmallViewport ? "64px" : "128px"
            })
        },
        {
            content: "Match with highly rated local caregivers near you",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                size: isSmallViewport ? "64px" : "128px"
            })
        },
        {
            content: "Compare options and choose the best fit",
            icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                size: isSmallViewport ? "64px" : "128px"
            })
        }, 
    ];
    var hiwStepsMobile = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
            item: true,
            container: true,
            children: hiwSteps.map(function(item) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                    sx: {
                        mb: 3
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            sx: {
                                mr: 3
                            },
                            children: item.icon
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                variant: "body2",
                                children: item.content
                            })
                        })
                    ]
                }, item.content);
            })
        });
    };
    var hiwStepsDesktop = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
            item: true,
            container: true,
            children: hiwSteps.map(function(item) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                    item: true,
                    sm: 4,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                        sx: {
                            mb: 3,
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                sx: {
                                    mr: 0,
                                    mb: 3
                                },
                                children: item.icon
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                sx: {
                                    width: {
                                        md: "70%"
                                    }
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                    variant: "body1",
                                    textAlign: "center",
                                    children: item.content
                                })
                            })
                        ]
                    }, item.content)
                }, item.content);
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        maxWidth: "xl",
        disableGutters: !isSmallViewport,
        sx: {
            mt: {
                xs: 6,
                sm: 8
            }
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                component: "h2",
                variant: isSmallViewport ? "h1" : "display3",
                mb: {
                    xs: 3,
                    sm: 6
                },
                textAlign: {
                    xs: "left",
                    sm: "center"
                },
                children: "Find caregivers near you that you'll love"
            }),
            isSmallViewport ? hiwStepsMobile() : hiwStepsDesktop(),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                width: {
                    xs: "270px",
                    sm: "315px",
                    md: "362px"
                },
                sx: {
                    pb: 5,
                    mx: "auto"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                    sx: {
                        mt: {
                            xs: 2,
                            md: 1
                        }
                    },
                    color: "primary",
                    component: "a",
                    fullWidth: true,
                    onClick: handleCtaBtn,
                    href: segmentationUrl,
                    size: "large",
                    variant: "contained",
                    rel: isCostGuideLandingPage ? "nofollow" : "",
                    children: ctaText
                })
            })
        ]
    });
};


/***/ }),

/***/ 75347:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 31777:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 34017:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 59905:
/***/ (function() {

/* (ignored) */

/***/ })

}]);